var React = require('react');

function IconShare (props) {
    return React.createElement("symbol",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M29.624 7.373l-5 4.998a1.245 1.245 0 0 1-1.77 0 1.248 1.248 0 0 1 0-1.767l2.868-2.866H19.99c-5.423 0-10.002 4.465-10.002 9.748a1.25 1.25 0 0 1-2.501 0c0-6.753 5.61-12.248 12.503-12.248h5.733l-2.867-2.865A1.25 1.25 0 1 1 24.623.605l5 5a1.25 1.25 0 0 1 0 1.768zm-22.138.365h-5v17.497h22.503v-8.748a1.25 1.25 0 0 1 2.502 0v8.748a2.504 2.504 0 0 1-2.502 2.5H2.485a2.503 2.503 0 0 1-2.5-2.5V7.738c0-1.377 1.122-2.5 2.5-2.5h5.001a1.25 1.25 0 1 1 0 2.5z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"transform":"translate(0 .255)","d":"M0 0h30v27.49H0z"})))]);
}

IconShare.displayName = "IconShare";

IconShare.defaultProps = {"viewBox":"0 0 30 28"};

module.exports = IconShare;

IconShare.default = IconShare;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/icon-share.svg
// module id = 1271
// module chunks = 0